import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core';

import stopWinIcon from '../../files/images/stop-win.svg';
import stopLossIcon from '../../files/images/stop-loss.svg';
import { formatPrice } from '../../utils/functions';

interface StopWinLossModalProps {
  open: boolean;
  onClose: () => void;
  type: 'win' | 'loss';
  stopValue: number;
  todayTotal: number;
}

export default function StopWinLossModal({
  open,
  onClose,
  type,
  stopValue,
  todayTotal,
}: StopWinLossModalProps) {
  const isWin = type === 'win';
  const title = isWin ? 'Stop Win Atingido!' : 'Stop Loss Atingido!';
  const imageSrc = isWin ? stopWinIcon : stopLossIcon;
  const accentColor = isWin ? '#4BDC4B' : '#FF7A63';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          background: '#2C325C',
          color: '#fff',
          borderRadius: '16px',
          maxWidth: '380px',
          width: '100%',
          textAlign: 'center',
          overflow: 'hidden',
        },
      }}
    >
      <div style={{
        background: isWin
          ? 'linear-gradient(180deg, #1a3a1a 0%, #2C325C 100%)'
          : 'linear-gradient(180deg, #3a1a1a 0%, #2C325C 100%)',
        padding: '32px 24px 16px',
      }}>
        <img
          src={imageSrc}
          alt={title}
          style={{
            width: '120px',
            height: '120px',
            objectFit: 'contain',
            marginBottom: '16px',
          }}
        />
        <Typography
          variant="h5"
          style={{
            color: accentColor,
            fontWeight: 700,
            marginBottom: '4px',
          }}
        >
          {title}
        </Typography>
      </div>

      <DialogContent style={{ padding: '24px' }}>
        <div style={{
          background: '#1E2141',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '8px',
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
          }}>
            <Typography variant="body2" style={{ color: '#ffffff99' }}>
              {isWin ? 'Stop Win' : 'Stop Loss'}
            </Typography>
            <Typography variant="body1" style={{ color: '#fff', fontWeight: 600 }}>
              {formatPrice(stopValue)}
            </Typography>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <Typography variant="body2" style={{ color: '#ffffff99' }}>
              Saldo de hoje
            </Typography>
            <Typography variant="body1" style={{
              color: accentColor,
              fontWeight: 700,
              fontSize: '1.1rem',
            }}>
              {formatPrice(todayTotal)}
            </Typography>
          </div>
        </div>

        <Typography variant="body2" style={{
          color: '#ffffff99',
          marginTop: '12px',
          fontSize: '0.8rem',
        }}>
          {isWin
            ? 'Considere encerrar suas operações por hoje para proteger seus ganhos.'
            : 'Considere encerrar suas operações por hoje para evitar mais perdas.'}
        </Typography>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'center', padding: '0 24px 24px' }}>
        <Button
          onClick={onClose}
          variant="contained"
          style={{
            background: accentColor,
            color: '#1E2141',
            fontWeight: 700,
            padding: '10px 48px',
            borderRadius: '8px',
          }}
        >
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
}
